import { createGlobalStyle } from 'styled-components';
import { DS_AI_KEYFRAMES_CSS } from './dealstackAi.animations';
import { DS_AI_FLOAT_FROM_VAR, DS_AI_MOTION_VAR, DS_AI_PANE_OPEN_VAR } from './dealstackAi.tokens';
import { useDsAiMotionFactor } from './useDsAiMotionFactor';

/** The feature's keyframes, injected once so every engine can name them. */
const DealstackAiKeyframes = createGlobalStyle`${DS_AI_KEYFRAMES_CSS}`;

const MotionVariables = createGlobalStyle<{ $factor: number }>`
	:root { ${DS_AI_MOTION_VAR}: ${({ $factor }) => $factor}; }
	[data-position^='top'] { ${DS_AI_FLOAT_FROM_VAR}: 4px; }
	@property ${DS_AI_PANE_OPEN_VAR} {
		syntax: '<number>';
		inherits: false;
		initial-value: 1;
	}
`;

/**
 * The variables DealStack AI motion reads, mounted once by the deal pages. Under `prefers-reduced-motion` the motion
 * factor is 0: entrances fade without rising, sliding or scaling, and widths, rotations, zooms and pulses jump. Unlike
 * the design, which cuts every animation, fades keep their timing (they do not move). Only the feature reads these, so
 * the app-wide Mantine setting is untouched. A dropdown placed above its target floats up into place, and a
 * collapsible panel's openness is registered once so its width can animate.
 */
export const DealstackAiMotionStyles = () => (
	<>
		<DealstackAiKeyframes />
		<MotionVariables $factor={useDsAiMotionFactor()} />
	</>
);
